/* SQINWEAR · Slider de fotos en tarjetas de producto */
(function () {
  var ARROW = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M6 3l5 5-5 5" stroke="currentColor"/></svg>';

  function setup(media) {
    if (media.dataset.sqinSlider) return;
    var slider = media.querySelector('.mobile-product-slider');
    if (!slider) return;
    var slides = slider.querySelectorAll('.mobile-product-slide');
    media.dataset.sqinSlider = '1';
    if (slides.length < 2) return;

    media.classList.add('sqin-has-slider');
    media.classList.remove('has-hover');

    var n = slides.length;
    var bar = document.createElement('div');
    bar.className = 'sqin-card-bar';
    bar.innerHTML = '<span style="width:' + (100 / n) + '%"></span>';
    media.appendChild(bar);
    var thumb = bar.firstChild;

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'sqin-card-arrow sqin-card-arrow--prev';
    prev.setAttribute('aria-label', 'Foto anterior');
    prev.innerHTML = ARROW.replace('<svg', '<svg style="transform:rotate(180deg)"');
    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'sqin-card-arrow sqin-card-arrow--next';
    next.setAttribute('aria-label', 'Foto siguiente');
    next.innerHTML = ARROW;
    media.appendChild(prev);
    media.appendChild(next);

    function index() {
      var w = slider.clientWidth || 1;
      return Math.max(0, Math.min(n - 1, Math.round(slider.scrollLeft / w)));
    }
    function update() {
      var i = index();
      thumb.style.transform = 'translateX(' + (i * 100) + '%)';
      prev.disabled = i === 0;
      next.disabled = i === n - 1;
    }
    function go(dir, e) {
      e.preventDefault();
      e.stopPropagation();
      slider.scrollTo({ left: (index() + dir) * slider.clientWidth, behavior: 'smooth' });
    }
    prev.addEventListener('click', function (e) { go(-1, e); });
    next.addEventListener('click', function (e) { go(1, e); });
    slider.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });

    /* Evita abrir el producto si el gesto ha sido un deslizamiento */
    var startX = 0, moved = false;
    slider.addEventListener('pointerdown', function (e) { startX = e.clientX; moved = false; });
    slider.addEventListener('pointermove', function (e) { if (Math.abs(e.clientX - startX) > 8) moved = true; });
    media.addEventListener('click', function (e) { if (moved) { e.preventDefault(); moved = false; } }, true);

    update();
  }

  function init(root) {
    (root || document).querySelectorAll('.card-product__media').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* Tarjetas cargadas después (cargar más, filtros, recomendaciones) */
  new MutationObserver(function (list) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].addedNodes.length) { init(); break; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* SQINWEAR · Ficha de producto: talla sin preseleccionar; el botón pide la talla hasta que se elige */
(function () {
  if (!document.body.classList.contains('template--product')) return;

  var BTN = 'product-form button[name="add"], product-bar button[name="add"]';

  function sizeGate() {
    if (new URLSearchParams(location.search).has('variant')) return; /* enlace a una talla concreta: se respeta */
    var root = document.querySelector('.product__selector');
    if (!root || root.dataset.sqinGate) return;
    var sets = root.querySelectorAll('fieldset');
    if (sets.length !== 1) return; /* solo productos con una única opción (talla) */
    var radios = sets[0].querySelectorAll('input[type="radio"]');
    if (radios.length < 2) return;
    root.dataset.sqinGate = '1';

    var chosen = false;
    radios.forEach(function (r) {
      r.checked = false;
      r.removeAttribute('checked');
    });
    sets[0].querySelectorAll('label').forEach(function (l) { l.classList.remove('is-active'); });

    /* "Elige tu talla" en el botón (se pinta por CSS para no chocar con el script que añade el precio) */
    function paint() {
      document.querySelectorAll(BTN).forEach(function (b) {
        b.classList.toggle('sqin-btn-choose', !chosen);
      });
    }
    paint();

    function markChosen() {
      chosen = true;
      paint();
    }
    radios.forEach(function (r) { r.addEventListener('change', markChosen); });
    var barSelect = document.querySelector('product-bar select[name^="options["]');
    if (barSelect) barSelect.addEventListener('change', markChosen);
    document.querySelectorAll('product-bar .dropdown__item-button:not(.pdp-quiz-slot-button)').forEach(function (b) {
      b.addEventListener('click', markChosen);
    });

    /* Sin talla elegida, el botón solo lleva a las tallas */
    function block(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      root.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    document.addEventListener('click', function (e) {
      if (chosen) return;
      var b = e.target.closest && e.target.closest(BTN);
      if (b) block(e);
    }, true);
    document.addEventListener('submit', function (e) {
      if (chosen) return;
      var f = e.target;
      if (f && f.matches && f.matches('form[action*="/cart/add"]') && f.closest('product-form, product-bar')) block(e);
    }, true);
  }

  /* Bloqueo de talla DESACTIVADO (prueba 24/09): para reactivarlo, volver a llamar a sizeGate() */
})();

/* SQINWEAR · Ficha de producto: Descripción / Envíos / Cuidados / Guía de tallas en pestañas (en el mismo sitio) */
(function () {
  if (!document.body.classList.contains('template--product')) return;

  /* Descripción: resumen de ~22 palabras con "Leer más" / "Leer menos" */
  function summary(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var parts = [];
    tmp.querySelectorAll('li, p').forEach(function (el) {
      if (el.querySelector('li, p')) return;
      var t = el.textContent.replace(/\s+/g, ' ').trim();
      if (!t) return;
      if (!/[.!?:]$/.test(t)) t += '.';
      parts.push(t);
    });
    var words = parts.join(' ').split(' ');
    if (words.length <= 25) return null;
    return words.slice(0, 22).join(' ').replace(/[.,;:]$/, '') + '…';
  }
  function moreBtn(label, onClick) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'sqin-ptabs__more';
    b.textContent = label;
    b.addEventListener('click', onClick);
    return b;
  }
  /* Pinta el contenido de una pestaña; la de Descripción sale resumida */
  function render(panel, tab) {
    var short = /descrip/i.test(tab.title) ? summary(tab.html) : null;
    if (!short) { panel.innerHTML = tab.html; return; }
    function collapsed() {
      panel.innerHTML = '';
      var p = document.createElement('p');
      p.appendChild(document.createTextNode(short + ' '));
      p.appendChild(moreBtn('Leer más', expanded));
      panel.appendChild(p);
    }
    function expanded() {
      panel.innerHTML = tab.html;
      var p = document.createElement('p');
      p.appendChild(moreBtn('Leer menos', collapsed));
      panel.appendChild(p);
    }
    collapsed();
  }
  window.sqinRenderTab = render;

  /* Cuidados: cada indicación en una ficha con su símbolo de lavado (mismo estilo que Envíos) */
  var CARE_CSS = '.sq-care{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:6px;font-family:"Helvetica Neue",Helvetica,Arial,sans-serif}'
    + '.sq-care__i{display:flex;align-items:center;gap:10px;padding:12px 10px;background:#f3ece4;font-size:12px;line-height:1.35;color:#111}'
    + '.sq-care__i--wide{grid-column:1/-1}'
    + '.sq-care__ic{flex:0 0 34px;width:34px;height:34px;border-radius:50%;background:#fff;display:flex;align-items:center;justify-content:center}'
    + '.sq-care__ic svg{width:22px;height:22px;fill:none;stroke:#111;stroke-width:1.3;stroke-linecap:round;stroke-linejoin:round}'
    + '.sq-care__ic text{fill:#111;stroke:none;font:600 6px Helvetica,Arial,sans-serif}';
  var X = '<path d="M5 5l14 14M19 5L5 19"/>';
  function careIcon(t) {
    var deg = (t.match(/(\d{2})\s*º?\s*c?/i) || [])[1];
    var no = /^\s*no\b/i.test(t);
    var s;
    if (/secadora|tumble/i.test(t)) s = '<rect x="4" y="4" width="16" height="16"/><circle cx="12" cy="12" r="5.5"/>';
    else if (/en seco|dry ?clean/i.test(t)) s = '<circle cx="12" cy="12" r="8"/>';
    else if (/lej[ií]a|blanque|bleach/i.test(t)) s = '<path d="M12 4l9 15H3z"/>';
    else if (/planch|iron/i.test(t)) s = '<path d="M4 17h16l-2.5-8H9c-3 0-5 3.5-5 8z"/><path d="M7.5 9V7h7"/>';
    else if (/lav|wash/i.test(t)) s = '<path d="M3 7l2 12h14l2-12"/><path d="M3 7c1.5 1.2 3 1.2 4.5 0s3-1.2 4.5 0 3 1.2 4.5 0 3-1.2 4.5 0"/>' + (deg ? '<text x="12" y="16.5" text-anchor="middle">' + deg + '</text>' : '');
    else if (/tend|secar|dry/i.test(t)) s = '<rect x="4" y="4" width="16" height="16"/><path d="M8 4v16M12 4v16M16 4v16"/>';
    else s = '<circle cx="12" cy="12" r="8.5"/><path d="m8.5 12.2 2.4 2.4 4.6-5"/>';
    return '<svg viewBox="0 0 24 24" aria-hidden="true">' + s + (no && !/^<circle cx="12" cy="12" r="8.5"/.test(s) ? X : '') + '</svg>';
  }
  function careText(t) {
    t = t.replace(/\s+/g, ' ').trim()
      .replace(/\bmaquina\b/gi, 'máquina').replace(/\bmax\./gi, 'máx.')
      .replace(/(\d{2})\s*º\s*c\b/gi, '$1 ºC').replace(/\blejia\b/gi, 'lejía');
    return t.charAt(0).toUpperCase() + t.slice(1);
  }
  function careHtml(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var items = [];
    tmp.querySelectorAll('li').forEach(function (li) { var t = li.textContent.trim(); if (t) items.push(t); });
    if (!items.length) tmp.querySelectorAll('p').forEach(function (p) { var t = p.textContent.trim(); if (t) items.push(t); });
    if (items.length < 2) return html;
    if (!document.getElementById('sq-care-css')) {
      var st = document.createElement('style'); st.id = 'sq-care-css'; st.textContent = CARE_CSS; document.head.appendChild(st);
    }
    var esc = function (s) { return s.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    return '<div class="sq-care">' + items.map(function (t, i) {
      var wide = (i === 0 && items.length % 2 === 1) ? ' sq-care__i--wide' : '';
      return '<div class="sq-care__i' + wide + '"><span class="sq-care__ic">' + careIcon(t) + '</span><span>' + esc(careText(t)) + '</span></div>';
    }).join('') + '</div>';
  }

  /* Guía de tallas: tabla general (igual para todas las prendas) + acceso al test «Encuentra tu talla» */
  var SIZES = [['S','36','86 - 91','67 - 73','94 - 99'],['M','38','93 - 98','74 - 79','100 - 106'],['L','40','99 - 104','80 - 88','107 - 112'],
    ['XL','42','105 - 113','89 - 97','113 - 121'],['2XL','44','114 - 122','98 - 106','122 - 130'],['3XL','46','123 - 132','107 - 116','131 - 140'],
    ['4XL','48','133 - 142','117 - 126','141 - 150'],['5XL','50','143 - 153','126 - 135','150 - 159']];
  var GUIDE_CSS = '.sq-sg{font-family:"Helvetica Neue",Helvetica,Arial,sans-serif;color:#111}'
    + '.sq-sg__t{width:100%;border-collapse:collapse;table-layout:fixed;font-size:11px;line-height:1.3;margin:6px 0 18px}'
    + '.sq-sg__t th,.sq-sg__t td{border:1px solid #e6e2e1;padding:14px 4px;text-align:center;font-weight:300;color:#333;font-variant-numeric:tabular-nums}'
    + '.sq-sg__t th{background:#f4f3ef;padding:12px 4px;font-size:9.5px;font-weight:500;letter-spacing:.08em;text-transform:uppercase;color:#111}'
    + '.sq-sg__t td:first-child{font-weight:500;color:#111}'
    + '.sq-sg__u{margin:-8px 0 20px!important;font-size:11px;color:#6f6a69}'
    + '.sq-sg__note{margin:0 0 16px!important;padding:16px;background:#f3ece4;font-size:13px;line-height:1.55}'
    + '.sq-sg__btn{display:inline-flex;align-items:center;justify-content:center;min-height:42px;padding:0 22px;border:1px solid #111;background:#fff;color:#111;font:500 12px "Helvetica Neue",Helvetica,Arial,sans-serif;letter-spacing:.06em;text-transform:uppercase;cursor:pointer}';
  function guideHtml() {
    if (!document.getElementById('sq-sg-css')) {
      var st = document.createElement('style'); st.id = 'sq-sg-css'; st.textContent = GUIDE_CSS; document.head.appendChild(st);
    }
    var rows = SIZES.map(function (r) { return '<tr>' + r.map(function (c) { return '<td>' + c + '</td>'; }).join('') + '</tr>'; }).join('');
    return '<div class="sq-sg">'
      + '<table class="sq-sg__t"><thead><tr><th colspan="2">Talla</th><th>Busto</th><th>Cintura</th><th>Caderas</th></tr></thead><tbody>' + rows + '</tbody></table>'
      + '<p class="sq-sg__u">Medidas del cuerpo en centímetros.</p>'
      + '<p class="sq-sg__note">Guía orientativa. Para acertar con tu talla en esta prenda, haz el test.</p>'
      + '<button type="button" class="sq-sg__btn" data-sq-open-quiz>Encuentra tu talla</button>'
      + '</div>';
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('[data-sq-open-quiz]')) return;
    var q = document.querySelector('.sqf-open');
    if (q) q.click();
    else { var s = document.querySelector('.product__selector'); if (s) s.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  });

  function build() {
    var host = document.querySelector('.section-complete-the-set .section__buttons');
    if (!host || host.dataset.sqinTabs) return;
    var tabs = [];
    host.querySelectorAll('menu-drawer').forEach(function (md) {
      var t = md.querySelector('.drawer__button-text');
      var body = md.querySelector('.drawer__content .rte');
      if (t && body) tabs.push({ title: t.textContent.trim(), html: body.innerHTML });
    });
    /* Orden: Descripción, Envíos, Guía de tallas, resto. Cuidados con iconos, como Descripción y Envíos. */
    tabs.forEach(function (t) {
      if (/env[ií]o/i.test(t.title)) t.title = 'Envíos';
      if (/cuidad|care/i.test(t.title)) t.html = careHtml(t.html);
    });
    var ei = -1;
    tabs.forEach(function (t, i) { if (t.title === 'Envíos') ei = i; });
    if (ei > 1) { tabs.splice(1, 0, tabs.splice(ei, 1)[0]); ei = 1; }
    var hasSizes = document.querySelector('#Size-Guide-menu-drawer') || document.querySelector('[id^="ProductSelector-"] fieldset');
    if (hasSizes) tabs.splice(Math.min(ei === 1 ? 2 : 1, tabs.length), 0, { title: 'Guía de tallas', html: guideHtml() });
    if (!tabs.length) return;
    host.dataset.sqinTabs = '1';

    var box = document.createElement('div');
    box.className = 'sqin-ptabs';
    var nav = document.createElement('div');
    nav.className = 'sqin-ptabs__nav';
    nav.setAttribute('role', 'tablist');
    var panel = document.createElement('div');
    panel.className = 'sqin-ptabs__panel rte';
    panel.setAttribute('role', 'tabpanel');
    tabs.forEach(function (tab, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('role', 'tab');
      b.className = 'sqin-ptabs__btn' + (i === 0 ? ' is-active' : '');
      b.textContent = tab.title;
      b.addEventListener('click', function () {
        nav.querySelectorAll('.sqin-ptabs__btn').forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        render(panel, tab);
        b.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      });
      nav.appendChild(b);
    });
    render(panel, tabs[0]);
    box.appendChild(nav);
    box.appendChild(panel);
    host.appendChild(box);
    host.classList.add('sqin-ptabs-host');
    /* La guía de tallas ya está en las pestañas: fuera el enlace junto a las tallas */
    document.body.classList.add('sqin-has-ptabs');
  }

  if (document.readyState === 'complete') build();
  else window.addEventListener('load', build);
})();

/* SQINWEAR · Klarna: a veces su servicio responde "sin contenido" y el mensaje no sale; se le vuelve a pedir */
(function () {
  if (!document.body.classList.contains('template--product')) return;
  function retry(k, n) {
    setTimeout(function () {
      var sr = k.shadowRoot;
      var empty = !sr || sr.innerHTML.length < 200;
      var amount = k.getAttribute('data-purchase-amount');
      if (!empty || !amount) return;
      k.setAttribute('data-purchase-amount', String(Number(amount) + 1));
      setTimeout(function () { k.setAttribute('data-purchase-amount', amount); }, 300);
      if (n < 3) retry(k, n + 1);
    }, n === 0 ? 2500 : 3000);
  }
  function run() { document.querySelectorAll('klarna-placement').forEach(function (k) { retry(k, 0); }); }
  if (document.readyState === 'complete') run();
  else window.addEventListener('load', run);
})();

/* SQINWEAR · Barra fija en packs con dos tallas: solo añade al carrito cuando se han elegido las dos */
(function () {
  if (!document.body.classList.contains('template--product')) return;
  var SEL = 'product-bar select[name^="options["]';
  function dropdowns(bar) { return bar ? bar.querySelectorAll('dropdown-input') : []; }

  document.addEventListener('change', function (e) {
    var s = e.target;
    if (!s || !s.matches || !s.matches(SEL)) return;
    var dd = s.closest('dropdown-input');
    if (dd) dd.classList.add('sqin-picked');
  }, true);

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('product-bar .product-bar__submit, product-bar button[name="add"]');
    if (!b) return;
    var dds = dropdowns(b.closest('product-bar'));
    if (dds.length < 2) return;
    var pending = Array.prototype.filter.call(dds, function (d) { return !d.classList.contains('sqin-picked'); });
    if (!pending.length) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    /* abre el siguiente selector que falta */
    setTimeout(function () {
      var det = pending[0].querySelector('details');
      if (det && !det.open) { var sum = det.querySelector('summary'); if (sum) sum.click(); }
    }, 150);
  }, true);
})();

/* SQINWEAR · Packs con dos tallas: la recomendación de talla va debajo de los dos selectores */
(function () {
  if (!document.body.classList.contains('template--product')) return;
  function fixReco() {
    var sets = document.querySelectorAll('.product__selector .product-selector__buttons');
    if (sets.length < 2) return;
    var reco = document.querySelector('.pdp-size-reco');
    var last = sets[sets.length - 1];
    if (reco && last.nextSibling !== reco) last.parentNode.insertBefore(reco, last.nextSibling);
  }
  window.addEventListener('load', function () { fixReco(); setTimeout(fixReco, 1000); setTimeout(fixReco, 2000); });
  setTimeout(fixReco, 1600);
})();

/* SQINWEAR · Compra rápida en tarjetas: los packs con dos tallas llevan a la ficha para elegir ambas */
(function () {
  function multi(b) { return (b.dataset.size || '').indexOf(' / ') !== -1; }
  function label() {
    document.querySelectorAll('.js-btn-size').forEach(function (b) {
      if (multi(b) && !b.dataset.sqinMulti) { b.dataset.sqinMulti = '1'; b.textContent = 'Elegir tallas'; }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', label); else label();
  new MutationObserver(label).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.js-btn-size');
    if (!b || !multi(b)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var card = b.closest('.card-product');
    var a = card && card.querySelector('a[href*="/products/"]');
    /* En móvil el panel de tallas se abre fuera de la tarjeta: se busca la tarjeta por la variante */
    if (!a && b.dataset.variantid) {
      var src = document.querySelector('.card-product .js-btn-size[data-variantid="' + b.dataset.variantid + '"]');
      var c2 = src && src.closest('.card-product');
      a = c2 && c2.querySelector('a[href*="/products/"]');
    }
    if (a) location.href = a.href;
    else if (b.dataset.variantid) location.href = '/variants/' + b.dataset.variantid;
  }, true);
})();

/* Ficha, móvil: "Mismo estilo" en cuadrícula -> se desactiva el carrusel (Swiper) para que funcione el deslizado de fotos de cada tarjeta */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  function apply() {
    if (!document.body || !document.body.classList.contains('template--product')) return;
    document.querySelectorAll('card-product-slider.swiper').forEach(function (el) {
      var s = el.swiper;
      if (!s) return;
      if (mq.matches && s.enabled) { s.disable(); s.setTranslate(0); }
      else if (!mq.matches && !s.enabled) { s.enable(); }
    });
  }
  function run() { apply(); setTimeout(apply, 800); setTimeout(apply, 2500); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
  if (mq.addEventListener) mq.addEventListener('change', apply); else mq.addListener(apply);
  new MutationObserver(function (list) {
    for (var i = 0; i < list.length; i++) { var t = list[i].target; if (t.classList && t.classList.contains('swiper-initialized')) { apply(); return; } }
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['class'] });
})();

/* Ficha: el extracto se muestra sin el ✔️ del inicio (el texto del metacampo no se toca) */
(function () {
  if (!document.body.classList.contains('template--product')) return;
  function clean() {
    document.querySelectorAll('.product__content .product__text--body').forEach(function (p) {
      p.childNodes.forEach(function (n) { if (n.nodeType === 3) n.textContent = n.textContent.replace(/^\s*✔️?\s*/, ''); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', clean); else clean();
})();

/* Ficha: "Flash Sale" sobre la foto (el tema solo lo pinta en productos rebajados).
   La copia de la foto NO lleva la clase .pdp-badge-flash: si la llevara, el script que coloca
   la etiqueta junto al precio la movería ahí y se irían acumulando varias "Flash Sale". */
(function () {
  if (!document.body.classList.contains('template--product')) return;
  function place() {
    document.querySelectorAll('.price .sqin-flash-media').forEach(function (x) { x.remove(); });
    var f = document.querySelector('.product__content .pdp-badge-flash:not(.sqin-flash-media)');
    var m = document.querySelector('.product__media');
    if (!f || !m || m.querySelector('.sqin-flash-media')) return;
    var c = f.cloneNode(true);
    c.classList.remove('pdp-badge-flash');
    c.classList.add('sqin-flash-media');
    c.style.cssText = 'position:absolute;bottom:14px;left:14px;z-index:5;display:inline-block;background:#111;color:#fff;font-size:10px;letter-spacing:.05em;text-transform:uppercase;padding:4px 8px;font-weight:400;white-space:nowrap;font-family:Helvetica,Arial,sans-serif;pointer-events:none';
    m.appendChild(c);
  }
  function run() { place(); setTimeout(place, 1000); setTimeout(place, 2500); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
})();

/* SQINWEAR · Ficha en ordenador (>=990px): fotos en rejilla de 2 columnas, info fija a la derecha
   y pestañas (Descripción, Envíos, Guía, Cuidados) debajo del botón y Klarna. Móvil sin cambios. */
(function () {
  if (!document.body.classList.contains('template--product')) return;
  var mq = window.matchMedia('(min-width: 990px)');
  var st = document.createElement('style');
  st.textContent = "@media screen and (min-width: 990px){.sqd-grid .product__grid{align-items: start;} .sqd-grid .product__grid__item--media{overflow: visible !important;margin-bottom: 56px !important;} .sqd-grid .product__media{position: relative !important;top: auto !important;height: auto !important;} .sqd-grid .product__media .product__media-slider, .sqd-grid .product__media .swiper{width: 100% !important;height: auto !important;overflow: visible !important;} .sqd-grid .product__media .swiper-wrapper{display: grid !important;grid-template-columns: 1fr 1fr;gap: 4px;transform: none !important;height: auto !important;cursor: default;} .sqd-grid .product__media .swiper-slide{width: auto !important;height: auto !important;margin: 0 !important;} .sqd-grid .product__media .swiper-pagination, .sqd-grid .product__media .swiper-buttons, .sqd-grid .product__media .product__modal-triggers{display: none !important;} .sqd-grid .product__media .pdp-badge-ship{top: 14px;bottom: auto;right: calc(50% + 16px);} .sqd-grid .product__media .sqin-flash-media{top: 14px !important;bottom: auto !important;} .sqd-grid .product__bar .product__tags{display: none !important;} .sqd-grid .product__grid__item--content{position: sticky;align-self: start;} .sqin-tabs-moved{display: none !important;} .shopify-section:has(.sqin-tabs-moved):not(:has(.card-product)):not(:has(.section__media img)){display: none !important;} .product__content > .sqin-ptabs{padding: 2rem 0 0;margin: 0;border-top: 1px solid #e6e2e1;}}";
  document.head.appendChild(st);

  var info, ro;
  function stickTop() {
    if (!info) return;
    var h = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
    var room = window.innerHeight - info.offsetHeight - 24;
    /* Si la info cabe, se queda fija bajo el header; si es más alta, baja hasta ver su final y ahí se queda */
    info.style.top = (mq.matches ? Math.min(h, room) : 0) + 'px';
  }
  function rowOf(el) { return parseInt(getComputedStyle(el).gridRowStart, 10) || 0; }
  function anchor(content) {
    var k = content.querySelector('klarna-placement');
    while (k && k.parentElement !== content) k = k.parentElement;
    return k || content.querySelector(':scope > product-form');
  }
  function tabs() {
    var box = document.querySelector('.sqin-ptabs');
    var host = document.querySelector('.sqin-ptabs-host');
    var content = document.querySelector('.product__content');
    if (!box || !host || !content) return;
    if (mq.matches) {
      if (box.parentElement === content) return;
      var a = anchor(content);
      var disp = getComputedStyle(content).display;
      if (/flex/.test(disp)) {
        /* Plantillas en flex con "order": mismo orden que Klarna y detrás de él */
        box.style.order = a ? getComputedStyle(a).order : '999';
        box.style.flex = '0 0 100%';
        box.style.width = '100%';
      } else if (disp === 'grid') {
        /* Justo debajo de Klarna: lo que va detrás baja una fila */
        var ar = a ? rowOf(a) : 0;
        if (!ar) Array.prototype.forEach.call(content.children, function (c) { ar = Math.max(ar, rowOf(c)); });
        Array.prototype.forEach.call(content.children, function (c) {
          var r = rowOf(c);
          if (r > ar) { c.dataset.sqdRow = c.style.gridRow || '-'; c.style.gridRow = String(r + 1); }
        });
        box.style.gridColumn = '1 / -1';
        box.style.gridRow = String(ar + 1);
      }
      if (a) content.insertBefore(box, a.nextSibling); else content.appendChild(box);
      host.classList.add('sqin-tabs-moved');
    } else if (box.parentElement !== host) {
      box.style.gridColumn = box.style.gridRow = box.style.order = box.style.flex = box.style.width = '';
      host.appendChild(box);
      host.classList.remove('sqin-tabs-moved');
      document.querySelectorAll('[data-sqd-row]').forEach(function (c) {
        c.style.gridRow = c.dataset.sqdRow === '-' ? '' : c.dataset.sqdRow;
        delete c.dataset.sqdRow;
      });
    }
    stickTop();
  }
  function setup() {
    var slides = document.querySelectorAll('.product__media-slider .swiper-wrapper > .swiper-slide');
    info = document.querySelector('.product__grid__item--content');
    if (slides.length > 1) document.body.classList.add('sqd-grid');
    if (info && window.ResizeObserver) { ro = new ResizeObserver(stickTop); ro.observe(info); }
    tabs();
    stickTop();
  }
  function onChange() { tabs(); stickTop(); }
  if (mq.addEventListener) mq.addEventListener('change', onChange); else mq.addListener(onChange);
  window.addEventListener('resize', stickTop);
  /* Las pestañas se montan en "load": esperar a que existan */
  if (document.readyState === 'complete') setTimeout(setup, 0);
  else window.addEventListener('load', function () { setTimeout(setup, 0); });
})();
